import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/medical-management/medical-equipment",
    component: MainPage,
    exact: false,
    name: "Equipos Médicos - Administración"
  }
];

export default routes;
